import React from 'react';
import { Button, Card, Col, Fade, Form, InputGroup, Row } from 'react-bootstrap';
import invite from 'assets/img/icons/spot-illustrations/41.png';
import demand from 'assets/img/icons/spot-illustrations/envelope.png';
import gmail from 'assets/img/logos/gmail.png';
import { Link } from 'react-router-dom';
import IconButton from 'components/common/IconButton';
import InvitePeopleModal from 'components/pages/miscellaneous/invite-people/InvitePeopleModal';
import Treeview from 'components/common/Treeview';
import useDemands from 'hooks/useDemands';

const Demands = () => {
 const { open, setOpen, treeviewItems, ruta, handleCopy, showModal, setShowModal, category } = useDemands();

 return (
  <>
   {ruta.pathname.startsWith('/1') == true ? (
    <>
     <Card>
      <Card.Body className="text-center py-5">
       <Row className="justify-content-center">
        <Col xs={7} md={5}>
         <img className="img-fluid" src={invite} alt="image" width="58%" />
        </Col>
       </Row>
       <h3 className="mt-3 fw-normal fs-2 mt-md-4 fs-md-3"> Gestione su Invitacion Aqui!</h3>
       <p className="lead mb-5">
        Invite a las personas que deseen registrarse
        <br className="d-none d-md-block" /> Compartiendoles el acceso a Inmovilii
       </p>
       <Row className="justify-content-center">
        <Col md="auto">
         <Form as={Row} className="g-2">
          <Col sm="auto">
           <InputGroup>
            <Button onClick={() => setOpen(!open)} aria-expanded={open} variant="falcon-primary">
             Editar
            </Button>
            <Form.Select>
             <option>categoria</option>
             {category.map(e => (
              <option key={e.id} value={e.id}>
               {e.category}
              </option>
             ))}
            </Form.Select>
           </InputGroup>
           <Fade in={open}>
            <div className="border rounded">
             <div className="p-x1">
              <Treeview data={treeviewItems} />
             </div>
            </div>
           </Fade>
          </Col>
          <Col sm="auto">
           <Form.Control type="email" placeholder="Correo Electronico" aria-label="Recipient's email" />
          </Col>
          <Col sm="auto">
           <Form.Control name="remuneracioninvite" type="text" placeholder="Remuneracion" aria-label="Recipient's remuneracion" />
          </Col>
          <Col sm="auto">
           <Button variant="primary" className="d-block w-100">
            Invitar
           </Button>
          </Col>
         </Form>
        </Col>
       </Row>
       <Card.Footer className="bg-light text-center pt-4">
        <Row className="justify-content-center">
         <Col xs={11} sm={10}>
          <h4 className="fw-normal mb-0 fs-1 fs-md-2">
           Mas formas de <br className="d-sm-none" /> invitar a tus contactos
          </h4>

          <Row className="gx-2 my-4">
           <Col lg={4}>
            <Button variant="falcon-default" className="d-block w-100 mb-2 mb-xl-0">
             <img src={gmail} width="20" alt="icon" />
             <span className="fw-medium ms-2">Invite para Gmail</span>
            </Button>
           </Col>
           <Col lg={4}>
            <IconButton
             className="d-block w-100 mb-2 mb-xl-0"
             iconClassName="me-2"
             variant="falcon-default"
             icon="link"
             onClick={handleCopy}
            >
             Copiar Link
            </IconButton>
           </Col>
           <Col lg={4}>
            <IconButton
             className="d-block w-100 mb-xl-0"
             variant="falcon-default"
             icon={['fab', 'facebook-square']}
             iconClassName="text-facebook me-2"
             transform="grow-2"
            >
             Compartir en Facebook
            </IconButton>
           </Col>
          </Row>
          <p className="mb-2 fs--1">
           <Link to="#!">ver el estado de tus referidos.</Link> <br className="d-none d-lg-block d-xxl-none" /> o visita
           <Link to="#!"> Nuestro Centro de Ayuda</Link>{' '}
          </p>
         </Col>
        </Row>
       </Card.Footer>
      </Card.Body>
     </Card>
    </>
   ) : ruta.pathname.startsWith('/settings') == false ? (
    <>
     <Card>
      <Card.Body className="text-center py-5">
       <Row className="justify-content-center">
        <Col xs={7} md={5}>
         <img className="img-fluid" src={demand} alt="image" width="45%" />
        </Col>
       </Row>
       <h3 className="mt-3 fw-normal fs-2 mt-md-4 fs-md-3"> Gestione su Solicitud Aqui!</h3>

       <Row className="justify-content-center">
        <Col md="auto">
         <Col md="auto">
          <Card bg={'light'}>
           <p className="lead mb-5">
            Podras hacer peticiones de ser Aliado a diferentes Empresas
            <br className="d-none d-md-block" /> Enviandoles un Mensaje desde Inmovilii
           </p>
           <Form as={Row} className="g-2 justify-content-center">
            <Col sm="auto" lg="10">
             <Form.Control name="asunto" type="text" placeholder="Asunto" aria-label="Recipient's asunto" />
             <Form.Control className="mt-2" name="nota" as="textarea" placeholder="Nota" aria-label="Recipient's Nota" />
            </Col>
            <Col sm="auto" lg="10">
             <Form.Control
              name="remuneraciondemand"
              type="text"
              placeholder="Remuneracion fija o porcentual"
              aria-label="Recipient's remuneracion"
             />
            </Col>

            <Button variant="primary" className=" justify-content-center">
             Enviar Solicitud
            </Button>
           </Form>
          </Card>
         </Col>
        </Col>
       </Row>
      </Card.Body>
     </Card>
    </>
   ) : null}
   <InvitePeopleModal show={showModal} setShow={setShowModal} />
  </>
 );
};

export default Demands;
